import { CloudDownload } from '@mui/icons-material';
import SelectAll from '@mui/icons-material/SelectAll';
import StarIcon from '@mui/icons-material/Star';
import { Divider, Grid, Link, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Module } from '@thro-types/modules-selections';
import { ShibUser } from '@thro-types/users';

import parse from 'html-react-parser';
import { Dispatch, SetStateAction, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

import { isModuleActive } from 'app/components/RichList/items/AWPM-FWPM/ModuleItem/helper';
import { handleDownload } from 'app/components/Util/downloadAttachement';
import {
  ModuleSelection,
  SelectionState,
  State,
  SubjectType
} from 'app/containers/AWPM-FWPM/ModuleSelections/models';
import { getCurrentSelectionState } from 'app/containers/AWPM-FWPM/helper';
import { translations } from 'locales/i18n';
import { Course } from 'types/AppTypes';

import { ControlButtons } from './ControlButtons';
import { ControlButtonsStudent } from './ControlButtonsStudent';
import { ParticipantConfiguration } from './ParticipantConfiguration';

interface Props {
  module: Module;
  isStudentView: boolean;
  showControlButtons: boolean;
  props: any;
  courses: Course[];
  setEditModalOpen: Dispatch<SetStateAction<boolean>>;
  setDeleteModalOpen: Dispatch<SetStateAction<boolean>>;
  setChangeStateModalOpen: Dispatch<SetStateAction<boolean>>;
  handleChangeIsTakingPlace: Dispatch<SetStateAction<boolean>>;
  setIsNotTakingPlaceModalOpen: Dispatch<SetStateAction<boolean>>;
  userData: ShibUser;
  selection?: ModuleSelection;
}

export const MoreInformation = ({
  module,
  isStudentView,
  showControlButtons,
  props,
  courses,
  setEditModalOpen,
  setDeleteModalOpen,
  setChangeStateModalOpen,
  handleChangeIsTakingPlace,
  setIsNotTakingPlaceModalOpen,
  userData,
  selection
}: Props) => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const anchorRef = useRef(null);

  return (
    <Grid item xs={12} md={9} className="moduleDetailView__moreInformation">
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={10}>
          <Typography component="h2">{module.name}</Typography>
          <Box className="ql-editor">{parse(module?.description ?? '')}</Box>
        </Grid>
        {!(
          isStudentView &&
          (!module?.isTakingPlace ||
            (!!selection &&
              (getCurrentSelectionState(selection) === SelectionState.Visible ||
                getCurrentSelectionState(selection) === SelectionState.ReadOnly ||
                getCurrentSelectionState(selection) === SelectionState.NotVisible)))
        ) && (
          <Grid
            item
            xs={2}
            container
            justifyContent="flex-start"
            direction="column"
            alignItems="center"
            spacing={3}
          >
            {showControlButtons && (
              <Grid item>
                {!isStudentView ? (
                  <ControlButtons
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                    anchorRef={anchorRef}
                    setEditModalOpen={setEditModalOpen}
                    setDeleteModalOpen={setDeleteModalOpen}
                    setChangeStateModalOpen={setChangeStateModalOpen}
                    handleChangeIsTakingPlace={handleChangeIsTakingPlace}
                    setIsNotTakingPlaceModalOpen={setIsNotTakingPlaceModalOpen}
                    isTakingPlace={module?.isTakingPlace}
                    isActive={isModuleActive(module)}
                    isDefault={module.isDefault}
                    selection={selection}
                  />
                ) : !(selection?.state === State.Started) ? (
                  <ControlButtonsStudent
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                    anchorRef={anchorRef}
                    userData={userData}
                    selection={selection}
                    module={module}
                  />
                ) : (
                  <></>
                )}
              </Grid>
            )}
            <Grid item>
              {props?.subjectType === SubjectType.Awpm ? (
                <Grid container alignItems="center">
                  <Grid item>
                    <StarIcon />
                  </Grid>
                  <Grid item>
                    <Typography component="h4">
                      {t(translations.pages.modules.awpm()).toUpperCase()}
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                <Grid container alignItems="center">
                  <Grid item>
                    <SelectAll />
                  </Grid>
                  <Grid item>
                    <Typography component="h4">
                      {t(translations.pages.modules.fwpm()).toUpperCase()}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
        {module.attachments && module.attachments.length > 0 && !isMobile && (
          <Grid item xs={10}>
            <Typography component="h2">
              {t(translations.pages.modules.create.GeneralInfo.attachments())}
            </Typography>
            <Grid item>
              {module?.attachments?.map(attachment => (
                <Link
                  onClick={() =>
                    handleDownload(
                      attachment.originalname,
                      `/modules/${module.id}/attachments/${attachment.id}/download`
                    )
                  }
                  key={attachment.name}
                  style={{ cursor: 'pointer' }}
                >
                  <CloudDownload color="primary" /> {attachment.originalname}
                </Link>
              ))}
            </Grid>
          </Grid>
        )}
      </Grid>
      {!isStudentView && module?.participantsConfigurations?.length > 0 && (
        <>
          <Divider />
          <Grid item xs={12}>
            <Typography component="h2">
              {t(translations.pages.modules.admissionCriteria())}
            </Typography>
            <Grid item xs={12}>
              {module.participantsConfigurations.map(parConf => {
                return (
                  <Grid item xs={12} key={parConf.id}>
                    <ParticipantConfiguration parConf={parConf} courses={courses} />
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};
